import React, { useEffect, useState } from "react";
import { ReactComponent as ShootingMenu } from "../Assets/svgs/entireshoot-menu.svg";
import { ReactComponent as SimilarMenu } from "../Assets/svgs/similar-menu.svg";
import { ReactComponent as DownloadMenu } from "../Assets/svgs/download-menu.svg";
import { ReactComponent as CartMenu } from "../Assets/svgs/cart-menu.svg";
import { ReactComponent as WishlistMenu } from "../Assets/svgs/wishlist-menu.svg";
import { ReactComponent as DeleteMenu } from "../Assets/svgs/dustbin-icon.svg";
import { ReactComponent as ZoomIcon } from "../Assets/svgs/zoomimage-menu.svg";
import { ReactComponent as CloseIcon } from "../Assets/svgs/close-icon-info.svg";
import {
  AddImageToWishlist,
  RemoveImageFromWishlist,
} from "../../services/WishListImages";
import { toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { wishlistDataSelector } from "../../redux/wishlist";
import { IconButton, Tooltip, Typography } from "@mui/material";
import DeleteConfirmationDialog from "../Modals/DeleteConfirmationDialog";
import ApiConfig, { BASE_IMAGE_URL } from "../../config/ApiConfig";
import "../Assets/css/layout.css";
import DownloadImage from "../Modals/DownloadImage";
import Loader from "./Loader";
import { GetSubscribedPlanData } from "../../services/ImageDownload";
import { videoInformationSelector } from "../../redux/videoInformation";
import { fetchFile } from "../../lib/helper";
import CryptoJS from "crypto-js";

const VideoMenu = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { wishlistData, triggerWishlistRerender, loadingWishlist } =
    useSelector(wishlistDataSelector);
  const { videoInformation } = useSelector(videoInformationSelector);
  const [openConfirmationDialog, setOpenConfirmationDialog] = useState(false);
  const [openDownloadModel, setOpenDownloadModel] = useState(false);
  const [loaderImage, setLoaderImage] = useState();
  const [selectedImageName, setSelectedImageName] = useState();
  const [isAlreadyWishlisted, setIsAlreadyWishlisted] = useState(false);
  const [showIcon, setShowIcon] = useState({
    showEntireShoot: true,
    showSameModel: false,
    showWishlist: true,
    showDelete: false,
    showInfo: true,
    showClose: false,
  });
  useEffect(() => {
    if (props.imageName) {
      checkAllWishlist();
    }
  }, [props.imageName]);
  useEffect(() => {
    if (triggerWishlistRerender) {
      checkAllWishlist();
    }
  }, [triggerWishlistRerender]);
  useEffect(() => {
    if (props.isWishlistMenu === true) {
      setShowIcon({
        ...showIcon,
        showEntireShoot: false,
        showWishlist: false,
        showDelete: true,
        showInfo: false,
      });
    }
    if (props.isEntireShoot === true) {
      setShowIcon({
        ...showIcon,
        showEntireShoot: false,
      });
    }
    if (props.isInfoPage === true) {
      setShowIcon({
        ...showIcon,
        showInfo: false,
        showClose: true,
      });
    }
  }, [props]);
  const checkAllWishlist = () => {
    if (
      wishlistData &&
      wishlistData?.items &&
      wishlistData?.items?.videoDetail?.length > 0
    ) {
      if (props.imageName) {
        const checkIsAlreadyWishlisted = wishlistData?.items?.videoDetail?.some(
          (imageData) => imageData.video_name === props.imageName
        );
        if (checkIsAlreadyWishlisted) {
          setIsAlreadyWishlisted(checkIsAlreadyWishlisted);
        } else {
          setIsAlreadyWishlisted(false);
        }
      }
    }
  };
  const handleAddToCart = () => {
    const tokenData = localStorage.getItem("token");
    if (tokenData) {
      window.open(`/addtocartvideo/${props.imageName}`, "_blank");
    } else {
      const afterLoginFunction = {
        type: "navigate",
        to: `/addtocartvideo/${props.imageName}`,
      };
      localStorage.setItem(
        "afterLogin",
        JSON.stringify(afterLoginFunction || {})
      );
      navigate("/signin");
      toast.error(`Please Login First`, {
        autoClose: 2500,
      });
    }
  };
  const handleDownloadImage = async () => {
    const tokenData = localStorage.getItem("token");
    if (tokenData) {
      const hasSubscribedPlan = await dispatch(GetSubscribedPlanData());
      if (hasSubscribedPlan === true) {
        setOpenDownloadModel(true);
        setSelectedImageName(props?.imageName);
      } else {
        navigate("/pricing");
      }
    } else {
      navigate("/signin");
      toast.error(`Please Login First`, {
        autoClose: 2500,
      });
    }
  };

  const handleImageDownload = async () => {
    try {
      // setLoadingImageDownload(true); 
      if (videoInformation?.items?.videoDetail) {
        // let planType = "WEB";
        // const encryptedImageName = CryptoJS.AES.encrypt(
        //   String(videoInformation?.items?.videoDetail?.video_name),
        //   process.env.REACT_APP_DOWNLOAD_AES_SECRET_KEY
        // ).toString();
        // const encryptedImageType = CryptoJS.AES.encrypt(
        //   String(planType),
        //   process.env.REACT_APP_DOWNLOAD_AES_SECRET_KEY
        // ).toString();

        // const encryptedShootId = CryptoJS.AES.encrypt(
        //   String(videoInformation?.items?.videoDetail?.shootid),
        //   process.env.REACT_APP_DOWNLOAD_AES_SECRET_KEY
        // ).toString();

        // const encryptedPayload = {
        //   video_name: encryptedImageName,
        //   imageType: encryptedImageType,
        //   shoot_id: encryptedShootId,
        // };
        // const fileTypeOfDownload = "2"

        toast.promise(
          fetchFile(
            `${ApiConfig?.videoDownLoad}?video_name=${videoInformation?.items?.videoDetail?.video_name}&shoot_id=${videoInformation?.items?.videoDetail?.shootid}`
          ),
          {
            pending: "Downloading your file....",
            success:
              `Video Clip Downloading!`,

            error: "Failed to download file.",
          }
        );

      }

      // setLoadingImageDownload(false);
    } catch (e) { }
  };
  const handleDownloadVideoClip = async () => {
    if (videoInformation?.items?.videoDetail?.vimeo_path) {
      toast.promise(
        fetchFile(videoInformation?.items?.videoDetail?.vimeo_path),
        {
          pending: "Downloading your file....",
          success:
            "Please wait while your Video/s is/are downloading. It may take a few moments.",
          error: "Failed to download file.",
        }
      );
    } else {
      const infoVideo = JSON.parse(localStorage.getItem("info-video"));
      if (infoVideo) {
        toast.promise(fetchFile(infoVideo?.url), {
          pending: "Downloading your file....",
          success:
            "Please wait while your Video/s is/are downloading. It may take a few moments.",
          error: "Failed to download file.",
        });
      } else {
        toast.error("There is some problem to download file please try later", {
          autoClose: 2500,
        });
      }
    }
  };
  const handleCloseDownloadDialog = () => {
    setOpenDownloadModel(false);
  };
  const handleAddVideoToWishlist = async () => {
    const tokenData = localStorage.getItem("token");
    setLoaderImage(props.imageName);
    if (tokenData) {
      const CustomToastWithLink = () => (
        <Link to="/wishlist">
          <div className="custom-toast-with-icon">
            <WishlistMenu className="custom-toast-icon" />
            <Typography
              variant="mainsectiontitle"
              component="div"
              className="boldFont"
            >
              Go to Wish List
            </Typography>
          </div>
        </Link>
      );
      const dataWithoutAPICall = {
        image_id:
          props.isEntireShoot === true
            ? props?.imageItem?.video_id
            : props.isSameModel === true
              ? props?.imageItem?.video_id
              : props?.isMoreInfoVideo === true
                ? props?.videoSno
                : props?.imageItem?._source?.ImageWebId,
        type: "2",
      };
      const response = await dispatch(AddImageToWishlist(dataWithoutAPICall));
      if (response === true) {
        toast(CustomToastWithLink, { autoClose: 2500 });
      }
      setLoaderImage();
    } else {
      const afterLoginFunction = {
        type: "wishlist",
        data: {
          image_id:
            props.isEntireShoot === true
              ? props?.imageItem?.video_id
              : props.isSameModel === true
                ? props?.imageItem?.video_id
                : props?.isMoreInfoVideo === true
                  ? props?.videoSno
                  : props?.imageItem?._source?.ImageWebId,
          type: "2",
        },
      };
      localStorage.setItem(
        "afterLogin",
        JSON.stringify(afterLoginFunction || {})
      );
      navigate("/signin");
      toast.error(`Please Login First`, {
        autoClose: 2500,
      });
      setLoaderImage();
    }
  };
  const handleEntireShootImage = (imageId) => {
    if (imageId !== undefined) {
      window.open(`/videoentireshoot/${props?.shootId}`, "_blank");
    }
  };
  const handleCloseConfirmationDialog = () => {
    setOpenConfirmationDialog(false);
  };
  const handleRemoveWishlistImage = async () => {
    const tokenData = localStorage.getItem("token");
    if (tokenData) {
      setOpenConfirmationDialog(true);
    } else {
      navigate("/signin");
      toast.error(`Please Login First`, {
        autoClose: 2500,
      });
    }
  };
  const handleDelteConfirmation = async () => {
    try {
      const payload = {
        image_id: props?.imageItem?.video_id,
      };
      dispatch(RemoveImageFromWishlist(payload));
      setOpenConfirmationDialog(false);
    } catch (e) {
      toast.error(`Something went wrong. Please try again.`, {
        autoClose: 2500,
      });
    }
    setOpenConfirmationDialog(false);
  };
  return (
    <>
      {openConfirmationDialog === true && (
        <DeleteConfirmationDialog
          open={openConfirmationDialog}
          onClose={handleCloseConfirmationDialog}
          imageLink={`${BASE_IMAGE_URL}${props?.imageItem?.shootid}/${props?.imageItem?.rank}-${props?.imageItem?.video_name}.jpg`}
          onConfirmation={handleDelteConfirmation}
        />
      )}
      {openDownloadModel && (
        <DownloadImage
          open={openDownloadModel}
          onClose={handleCloseDownloadDialog}
          selectedType="2"
          selectedImageName={selectedImageName}
        />
      )}
      {props.hasImageZoomMenu === true && (
        <div className="image-menu-zoom">
          <IconButton
            className="zoomImageButton"
            onClick={() => props.handleOpenModal()}
          >
            <ZoomIcon className="image-menu-vertical-icon image-menu-icon" />
          </IconButton>
        </div>
      )}
      {props.hasImageCloseMenu === true && (
        <div className="image-menu-zoom">
          <IconButton
            className="zoomImageButton"
            onClick={() => window.close()}
          >
            <CloseIcon className="image-menu-vertical-icon image-menu-icon" />
          </IconButton>
        </div>
      )}
      <div className="image-menu-main">
        <div
          className={
            props?.isMoreInfoVideo === true
              ? "video-menu-container"
              : "image-menu-container"
          }
        >
          <div>
            {showIcon.showEntireShoot === true && (
              <Tooltip title="Entire Shoot" arrow placement="top">
                <IconButton
                  className="ImageMenuButtonHorizontal"
                  onClick={() => handleEntireShootImage(props.imageName)}
                >
                  <ShootingMenu className="image-menu-horizontal-icon image-menu-icon" />
                  {props?.isMoreInfoVideo === true && (
                    <Typography
                      variant="sectiondata"
                      className="font-white"
                      component="div"
                      sx={{
                        marginLeft: "10px",
                        "@media only screen and (min-width: 280px) and (max-width: 1024px)":
                        {
                          display: "none",
                        },
                      }}
                    >
                      Entire Shoot
                    </Typography>
                  )}
                </IconButton>
              </Tooltip>
            )}
            {props?.isMoreInfoVideo === true && (
              <Tooltip title="Download Clip" arrow placement="top">
                <IconButton
                  className="ImageMenuButtonHorizontal"
                  disabled={true}
                >
                  <SimilarMenu className="image-menu-horizontal-icon image-menu-icon" />
                  {props?.isMoreInfoVideo === true && (
                    <Typography
                      variant="sectiondata"
                      className="font-white"
                      component="div"
                      sx={{
                        marginLeft: "10px",
                        "@media only screen and (min-width: 280px) and (max-width: 1024px)":
                        {
                          display: "none",
                        },
                      }}
                    >
                      Exclusive Rights : Not Available
                    </Typography>
                  )}
                </IconButton>
              </Tooltip>
            )}
            <Tooltip title="Download" arrow placement="top">
              <IconButton
                className="ImageMenuButtonHorizontal"
                onClick={() => handleDownloadImage()}
              >
                <DownloadMenu className="image-menu-horizontal-icon image-menu-icon" />
                {props?.isMoreInfoVideo === true && (
                  <Typography
                    variant="sectiondata"
                    className="font-white"
                    component="div"
                    sx={{
                      marginLeft: "10px",
                      "@media only screen and (min-width: 280px) and (max-width: 1024px)":
                      {
                        display: "none",
                      },
                    }}
                  >
                    Download
                  </Typography>
                )}
              </IconButton>
            </Tooltip>
            {props?.isMoreInfoVideo === true && (
              <Tooltip title="Download Clip" arrow placement="top">
                <IconButton
                  className="ImageMenuButtonHorizontal"
                  onClick={() => {
                    // handleDownloadVideoClip()
                    handleImageDownload()
                  }}
                >
                  <DownloadMenu className="image-menu-horizontal-icon image-menu-icon" />
                  {props?.isMoreInfoVideo === true && (
                    <Typography
                      variant="sectiondata"
                      className="font-white"
                      component="div"
                      sx={{
                        marginLeft: "10px",
                        "@media only screen and (min-width: 280px) and (max-width: 1024px)":
                        {
                          display: "none",
                        },
                      }}
                    >
                      Download Clip
                    </Typography>
                  )}
                </IconButton>
              </Tooltip>
            )}
          </div>
          <div className="image-menu-name">
            <Typography
              variant="sectiondata"
              className="font-white"
              component="div"
            >
              {props.imageName}
            </Typography>
          </div>
          <div className="image-menu-right-icon">
            <Tooltip title="Add To Cart" arrow placement="top">
              <IconButton
                className="ImageMenuButtonHorizontal"
                onClick={() => handleAddToCart()}
              >
                <CartMenu className="image-menu-horizontal-icon image-menu-icon" />
              </IconButton>
            </Tooltip>
            {showIcon.showWishlist === true && (
              <Tooltip title="Add To Wishlist" arrow placement="top">
                <IconButton
                  className="ImageMenuButtonHorizontal"
                  onClick={() => handleAddVideoToWishlist(props.imageName)}
                >
                  <WishlistMenu
                    className={`${isAlreadyWishlisted === true
                        ? "wishlisted-image-icon"
                        : ""
                      } image-menu-horizontal-icon image-menu-icon`}
                  />
                </IconButton>
              </Tooltip>
            )}
            {showIcon.showDelete === true && (
              <Tooltip title="Remove From Wishlist" arrow placement="top">
                <IconButton
                  className="ImageMenuButtonHorizontal"
                  onClick={() => handleRemoveWishlistImage(props.imageName)}
                >
                  <DeleteMenu className="image-menu-horizontal-icon image-menu-icon" />
                </IconButton>
              </Tooltip>
            )}
          </div>
        </div>
      </div>
      {loaderImage === props.imageName && loadingWishlist && <Loader />}
    </>
  );
};

export default React.memo(VideoMenu);

VideoMenu.defaultProps = {
  handleOpenModal: () => { },
};
